/**
 * Clears the table data filters.
 */
export function dashboardHeader() {
  const $container = $( '.o__header' );
  const $sharedEntriesdashboardMenu = $( '#menu-dashboard li.shared' );
  const sharedEntries = $container.attr( 'has-shared-entries' );
  if ( !sharedEntries ) {
    $sharedEntriesdashboardMenu.hide();
  }
}